import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button  from '../../../common/components/button';

export class FileUploadPauseContent extends PureComponent {
    render() {
        const { yesClick, noClick } = this.props;

        return (
            <div>
                <h1>Confirm Stop Upload</h1>
                <br />
                <p>Are you sure you want to stop the upload?</p>
                <p className="smaller">Stopping the upload will cancel all pending uploads and clear your upload queue.</p>
                <br />
                <div className="btn-dialog-container">
                    <Button buttonStyle="primary" className="btn-dialog" buttonLabel="Yes" onClick={yesClick} />
                    <Button buttonStyle="secondary" className="btn-dialog" buttonLabel="No" onClick={noClick} />
                </div>
            </div>
        );
    }
}

FileUploadPauseContent.propTypes = {
    yesClick: PropTypes.func.isRequired,
    noClick: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/upload/components/dialog/file-upload-pause-upload-content.jsx